import {Observable} from 'rxjs';
import {marineHubAPI} from '../provider/marineHubAPI';
import {RestQueryParams} from '../base/queryParams';

export function clearChatNotification(accessToken: string, notificationId): Observable<any> {
    return marineHubAPI.delete(`notifications/${notificationId}`, new RestQueryParams(), {
        Authorization: `Bearer ${accessToken}`,
    });
}
